'use strict';

var _taggedTemplateLiteral = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  color: ", ";\n  background-color: ", ";\n  font-weight: bold;\n  font-size: 7px;\n  line-height: 1;\n  border-radius: 3px;\n  padding-top: 2px;\n  padding-bottom: 2px;\n  padding-left: 6px;\n  padding-right: 4px;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _styled = require('../../styled');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var ComingSoonLabel = _styledComponents2.default.span(_templateObject(), _styled.colors.white, function (props) {
  return props.theme.platformPrimary;
});

exports.default = {
  ComingSoonLabel: ComingSoonLabel
};